/**
 * Meta (Facebook) Pixel – egyedi események követésére.
 * Használat: import { trackMetaEvent } from './utils/facebookPixel';
 *
 * Standard események: CompleteRegistration, Lead, Schedule, AddPaymentInfo, Purchase, ViewContent stb.
 * https://developers.facebook.com/docs/meta-pixel/reference
 */
export function trackMetaEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', eventName, params);
}

// Gyakori események a Frame-Book kontextusban
export const metaEvents = {
  completeRegistration: (params) => trackMetaEvent('CompleteRegistration', params),
  lead: (params) => trackMetaEvent('Lead', params),
  schedule: (params) => trackMetaEvent('Schedule', params),
  addPaymentInfo: (params) => trackMetaEvent('AddPaymentInfo', params),
  purchase: (params) => trackMetaEvent('Purchase', params),
  viewContent: (params) => trackMetaEvent('ViewContent', params),
};
